/**
 * Created by Denis Kuzin on 18 october 2024
 */

const HoseLevel = function (stage, progress) {
    this.stage = stage;
    this.progress = progress;

    this.level = new Level(stage, progress);

    const location = cleverapps.meta.getSelectedLocation();

    let currentStage = location.getStage();
    let currentProgress = location.getProgress();
    if (location.isCompleted() && location.canMoveNext()) {
        currentStage++;
        currentProgress = 0;
    }

    if (this.stage < currentStage) {
        this.type = Level.TYPE_PASSED;
    } else if (this.stage > currentStage) {
        this.type = Level.TYPE_NOTPASSED;
    } else if (this.progress < currentProgress) {
        this.type = Level.TYPE_PASSED;
    } else if (this.progress === currentProgress) {
        this.type = Level.TYPE_CURRENT;
    } else {
        this.type = Level.TYPE_NOTPASSED;
    }

    this.stars = (this.type === Level.TYPE_PASSED) ? 3 : 0;
};

HoseLevel.prototype.onPressed = function () {
    return this.level.onPressed();
};

HoseLevel.prototype.isHard = function () {
    return this.level.isHard();
};

HoseLevel.prototype.isBonus = function () {
    return this.level.isBonus();
};

HoseLevel.prototype.isTricky = function () {
    return this.level.isTricky();
};

HoseLevel.prototype.getHumanReadableNumber = function () {
    return this.stage * HoseLocation.LEVELS_PER_LOCATION + this.progress + 1;
};